__webpack_require__.p = "/static/iris/carbonio-shell-ui/21ab6d30ac3883f6292d87c3ed7174a796728475/";